import AddOnInputServices from "../services/AddOnInput";
export const FETCH_ADD_ON_INPUTS_SUCCESS = "FETCH_ADD_ON_INPUTS_SUCCESS";

export const GET_ADD_ON_INPUTS_SUCCESS = "GET_ADD_ON_INPUTS_SUCCESS";
export const GET_ADD_ON_INPUTS_FAILED = "GET_ADD_ON_INPUTS_FAILED";

const fetchAddOnInputsSuccess = (addOnInputs) => ({
  type: FETCH_ADD_ON_INPUTS_SUCCESS,
  payload: addOnInputs,
});

// fetch brands
export const fetchAddOnInputs = (addOnInputs) => {
  return (dispatch) => {
    dispatch(fetchAddOnInputsSuccess(addOnInputs));
  };
};
//////////////////

export const getAddOnInputs = () => {
  return (dispatch) => {
    AddOnInputServices.getAll()
      .then((res) => {
        dispatch({
          type: GET_ADD_ON_INPUTS_SUCCESS,
          payload: res,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_ADD_ON_INPUTS_FAILED,
          payload: err,
        });
      });
  };
};
